export const AppTitle = "Codewarp.in"
export const AdSlotCodeWarpHorizontal ="1093400215";
export const AdSlotCodeWarpfixed ="2285593771";
export const showAds = 0;